import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="28tw62tsgwo4i">
      <MetaPixel data-id="element-1" data-mp="28suu8n3mnxlq" />
      <UtmifyScript data-id="element-2" data-mp="28sbb5328r364" />
      <CountdownBar data-id="element-3" data-mp="23vchelmhoy8g" />
      <main data-id="element-4" data-mp="23vupcfiil0w7">
        <Hero data-id="element-5" data-mp="23u9u0nodldxa" />
        <StatsBar data-id="element-6" data-mp="23ujha3i1d6za" />
        <Difference data-id="element-7" data-mp="23t8heerpojdg" />
        <Recognize data-id="element-8" data-mp="3ijxqiu0iq6lh" />
        <WhatsInside data-id="element-9" data-mp="3ikhaeg9qb525" />
        <InstantAccess data-id="element-10" data-mp="3iiwasc8k4vxf" />
        <Bonuses data-id="element-11" data-mp="3ijpcuzwkmx98" />
        <Offer data-id="element-12" data-mp="3ii4r9zs8ioni" />
        <Guarantee data-id="element-13" data-mp="3mlavz2zp87rv" />
        <Testimonials data-id="element-14" data-mp="3mkrc3gqhn9b7" />
        <Faq data-id="element-15" data-mp="3mjzsz5e2v41t" />
      </main>
      <Footer data-id="element-16" data-mp="3mjgczu7zmpqf" />
    </div>;
}